import store from '@/store/index'
import request from '@/utils/request'

export function getData(url, params) {
  // 参数
  return request({
    url: url, method: 'get', params
  })
}

export function getDataByToken(url, params) {
  params['token'] = store.state.user.token
  // 参数
  return request({
    url: url, method: 'get', params
  })
}

/**
 * post 发送数据
 * @param url
 * @param dataJson
 * @param token
 * @returns {*}
 */
export function postData(url, dataJson, token) {
  // const date = JSON.stringify(dataJson)
  // date = encodeURIComponent(date)
  // const params = { 'data': date }
  // 参数
  return request({
    url,
    method: 'post',
    data: { data: dataJson }
  })
}

export function postDataByToken(url, dataJson) {
  const token = store.state.user.token
  const date = JSON.stringify(dataJson)
  const params = { 'token': token, 'data': date }
  // 参数
  return request({
    url: url, method: 'post', data: params
  })
}

// ========== ========== ========== 获取界面样式 ========== ========== ==========

// List界面
export function getListFrame(model, entity) {
  // 如果是测试模式，重设请求地址
  const tModel = store.getters['setting/getModel']
  if (tModel === '1') {
    const params = { 'token': store.getters['user/getToken'] }
    // 参数
    return request({
      url: model + '/' + entity + '/getListFrame', method: 'get', params
    })
  } else {
    return getData('/kvms/viewModel/getListViewFrame', {
      modelCode: model, entityCode: entity
    })
  }
}

// Info界面
export function getInfoFrame(model, entity) {
  // 如果是测试模式，重设请求地址
  const tModel = store.getters['setting/getModel']
  if (tModel === '1') {
    const params = { 'token': store.getters['user/getToken'] }
    // 参数
    return request({
      url: model + '/' + entity + '/getInfoFrame', method: 'get', params
    })
  } else {
    return getData('/kvms/viewModel/getInfoViewFrame', {
      modelCode: model, entityCode: entity
    })
  }
}

// Search界面
export function getSearchFrame(model, entity) {
  // 如果是测试模式，重设请求地址
  const tModel = store.getters['setting/getModel']
  if (tModel === '1') {
    const params = { 'token': store.getters['user/getToken'] }
    // 参数
    return request({
      url: model + '/' + entity + '/getSearchFrame', method: 'get', params
    })
  } else {
    return getData('/kvms/viewModel/getSearchViewFrame', {
      modelCode: model, entityCode: entity
    })
  }
}

// Search界面
export function getComListViewFrame(model, entity) {
  // 如果是测试模式，重设请求地址
  const tModel = store.getters['setting/getModel']
  if (tModel === '1') {
    const params = { 'token': store.getters['user/getToken'] }
    // 参数
    return request({
      url: model + '/' + entity + '/getListFrame', method: 'get', params
    })
  } else {
    return getData('/kvms/viewModel/getComListViewFrame', {
      modelCode: model, entityCode: entity
    })
  }
}

// ========== ========== ========== 操作Api接口 ========== ========== =========
export function save(url, dataJson) {
  let date = JSON.stringify(dataJson)
  date = encodeURIComponent(date)
  const params = { 'token': store.getters['user/getToken'], 'data': date }
  // 参数
  return request({
    url: url + '/do/save', method: 'post', data: params
  })
}

export function update(url, dataJson) {
  let date = JSON.stringify(dataJson)
  date = encodeURIComponent(date)
  const params = { 'token': store.getters['user/getToken'], 'data': date }
  // 参数
  return request({
    url: url + '/do/update', method: 'post', data: params
  })
}

export function remove(url, id) {
  const params = { 'token': store.getters['user/getToken'], 'id': id }
  // 参数
  return request({
    url: url + '/do/delete', method: 'get', params
  })
}

// ========== ========== ========== 查询Api接口 ========== ========== =========
export function getById(url, id) {
  const params = {}
  params['token'] = store.getters['user/getToken']
  params['id'] = id
  // 参数
  return request({
    url: url + '/get/findById', method: 'get', params
  })
}

export function getByCode(url, code) {
  const params = {}
  params['token'] = store.getters['user/getToken']
  params['code'] = code
  // 参数
  return request({
    url: url + '/get/findByCode', method: 'get', params
  })
}

export function findAll(url, searchDataJson) {
  const dataJson = {}
  dataJson['searchData'] = searchDataJson
  const date = JSON.stringify(dataJson)
  const params = { 'token': store.getters['user/getToken'], 'data': date }
  // 参数
  return request({
    url: url + '/find/findAll', method: 'post', data: params
  })
}
export function findUnique(url, searchDataJson) {
  const dataJson = {}
  dataJson['searchData'] = searchDataJson
  const date = JSON.stringify(dataJson)
  const params = { 'token': store.getters['user/getToken'], 'data': date }
  // 参数
  return request({
    url: url + '/get/findUnique', method: 'post', data: params
  })
}
export function findPage(url, searchDataJson, pageSize, pageNo) {
  const dataJson = {}
  dataJson['searchData'] = searchDataJson
  dataJson['pageSize'] = pageSize
  dataJson['pageNo'] = pageNo
  const date = JSON.stringify(dataJson)
  const params = { 'token': store.getters['user/getToken'], 'data': date }

  // 参数
  return request({
    url: url + '/find/findPagination', method: 'post', data: params
  })
}

/**
 * 通过关键词搜索
 * @param url
 * @param keyword
 * @returns {AxiosPromise}
 */
export function findByKeyword(url, keyword) {
  const dataJson = {}
  dataJson['searchData'] = keyword
  const date = JSON.stringify(dataJson)
  const params = { 'token': store.getters['user/getToken'], 'data': date }

  // 参数
  return request({
    url: url + '/find/getmedprescription', method: 'post', data: params
  })
}
export function findByKeyword2(url, keyword) {
  let dataJson = {}
  dataJson = keyword
  const date = JSON.stringify(dataJson)
  const params = { 'token': store.getters['user/getToken'], 'data': date }

  // 参数
  return request({
    url: url + '/find/getprescription', method: 'post', data: params
  })
}
export function findCount(model, entity, searchDataJson) {
  const searchData = JSON.stringify(searchDataJson)
  // searchData = encodeURIComponent(searchData)
  const params = {}
  params['token'] = store.getters['user/getToken']
  params['searchData'] = searchData
  // 参数
  return request({
    url: model + '/' + entity + '/find/count', method: 'get', params
  })
}

export function findPopup(url, searchDataJson, pageSign, pageSize, pageNo) {
  const dataJson = {}
  dataJson['searchData'] = searchDataJson
  if (pageSign) {
    dataJson['pageSize'] = pageSize
    dataJson['pageNo'] = pageNo
  }
  const date = JSON.stringify(dataJson)
  const params = { 'token': store.getters['user/getToken'], 'data': date }
  // 参数
  return request({
    url: url, method: 'post', data: params
  })
}
/**
 * post 上传文件（multipart/form-data）
 * @param {string} url
 * @param {FormData} formData
 * @returns {AxiosPromise}
 */
export function postFileData(url, formData) {
  return request({
    url,
    method: 'post',
    data: formData
  })
}
